import React, { useState } from "react";
import "./index.scss";
import LocationModal from "../../Modals/locationsModal";
import LocationItem from "../../LocationItem";

export default function Locations() {
  const [address, setAddress] = useState("");
  const [currentAddress, setCurrentAddress] = useState(null);

  const [showPopup, setPopup] = useState(false);

  const openPopup = () => {
    setPopup(true);
  };

  return (
    <div className="locations">
      <div className="locations__popup">
        {showPopup && (
          <LocationModal
            setPopup={setPopup}
            address={address}
            currentAddress={currentAddress}
            setCurrentAddress={setCurrentAddress}
            setAddress={setAddress}
          />
        )}
      </div>
      <div className="locations__head">
        <p className="locations__title">Locations</p>
        <div onClick={openPopup} className="locations__btn">
          <span>
            <img src="../../assets/icons/plus-white.svg" alt="plus" />
          </span>
          New location
        </div>
      </div>
      <div className="locations__table">
        <div className="locations__table-head">
          <div className="locations__table-headItem">Address</div>
          <div className="locations__table-headItem">City</div>
          <div className="locations__table-headItem">State</div>
          <div className="locations__table-headItem">Zip</div>
          <div className="locations__table-headItem">Country</div>
        </div>
        <div className="locations__table-content">
          <LocationItem
            setCurrentAddress={setCurrentAddress}
            currentAddress={currentAddress}
            openPopup={openPopup}
            setAddress={setAddress}
          />
        </div>
      </div>
    </div>
  );
}
